// ─── Pinned conversations + private chat names (owner, 2026-10-21) ──────────
//
// « Each user can pin conversations and add names to them. Pinning will not
// affect other users' interface — they won't see it. » The worker keeps one
// row per (signed-in user, conversation) and only ever answers with the
// caller's own rows (worker routes/chatPrefs.ts, migration 260).
//
// A file of its own, like lib/pushPrefsApi.ts, so parallel work on lib/api.ts
// never collides with it.
import { apiFetch } from './api';

/** Mirrors `ChatPrefRow` in worker routes/chatPrefs.ts. */
export interface ChatPref {
  chat_key: string;
  chat_id: string;
  pinned_at: string | null;
  custom_name: string | null;
  updated_at: string;
}

export interface ChatPrefSave {
  chat_key: string;
  chat_id: string;
  pinned: boolean;
  pinned_at: string | null;
  custom_name: string | null;
  /** The caller's other rows for this same person, folded into this one. */
  aliases: string[];
}

export const chatPrefsApi = {
  /** The signed-in user's pins and names. `installed: false` = migration 260 not applied yet. */
  list: () => apiFetch<{ installed: boolean; prefs: ChatPref[] }>('/chat-prefs'),
  save: (body: ChatPrefSave) =>
    apiFetch<{ ok: boolean; pref: ChatPref | null }>('/chat-prefs', { method: 'PUT', body: JSON.stringify(body) }),
};
